module.exports = __webpack_public_path__ + "media/jobs_page/heroimg_countryjobs_desktop-23f7529b.jpg";